import React, { useCallback } from "react";
import classNames from "classnames";
import { FilterIcon } from "./Icons";
import { useLocation, useHistory } from "react-router-dom";
import _ from "lodash";
import { parseURLSearch, updateURLSearch } from "utils/urlUtil";

export default function FilterableCell({ filterKey, children, value, className, getFilterValue, showFilter=true }) {
  const location = useLocation();
  const history = useHistory();
  const applyFilter = useCallback((e) => {
    e.stopPropagation();
    const { filters, query, savedSearch, pagination: urlPagination, groupBy } = parseURLSearch(location.search, true);
    const pagination = {
      ...urlPagination,
      page: 0,
    };
    filters[filterKey] = _.isFunction(getFilterValue) ? getFilterValue(value) : [_.isUndefined(value) ? children : value];
    updateURLSearch(history, { pagination, filters, query, savedSearch, groupBy });
  }, [filterKey, value, location.search, children, history, getFilterValue]);

  return (
    <div className={classNames(className, "filterable-cell")}>
      <span className="filterable-cell-content">
        {children}
      </span>
      {showFilter && (
        <span className="filter-icon" onClick={applyFilter}>
          <FilterIcon />
        </span>
      )}
    </div>
  );
}
